<div
  class="cpt-modal relative ef-scrollbar justify-start"
>
  <div mat-dialog-title class="md:px-10">
    {{ dialogData.title }}
  </div>

  <mat-dialog-content
    class="p-0 pt-6 max-h-[85vh] relative"
    [ngClass]="{
      'md:px-6 md:min-h-[80vh]': dialogData?.iframe === Iframe.ConsentManagement
    }"
  >
    @if (loading()) {
      <div class="absolute inset-0 flex items-center justify-center">
        <customer-portal-ef-spinner></customer-portal-ef-spinner>
      </div>
    }
    <iframe
      #iframeRef
      [frameBorder]="0"
      [src]="dialogData.url | DOMSafeUrl"
      [ngClass]="{ invisible: loading() }"
      class="w-full h-full"
      fetchpriority="high"
      (load)="onIframeLoad()"
    >
    </iframe>
  </mat-dialog-content>

  <button class="dialog-close-button md:right-10" [mat-dialog-close]="false">
    <mat-icon svgIcon="close"></mat-icon>
  </button>
</div>
